import DataFallback from './DataFallback';
import './DataFallback.scss';

export default DataFallback;